import { createSelector } from '@ngrx/store';
import { Order } from '../../models/order.model';
import * as fromRoot from '../../../store';
import * as fromFeature from '../reducers';
import * as fromOrders from '../reducers/orders.reducer';

export const getOrdersState = createSelector(fromFeature.getShopifyState, (state: fromFeature.ShopifyState) => state.orders);

export const getOrderEntities = createSelector(getOrdersState, fromOrders.getOrders);
export const getOrders = createSelector(getOrderEntities, entities => {
  return Object.keys(entities).map(id => entities[id as unknown as number]) as Order[];
});
export const getOrderedOrders = createSelector(getOrderEntities, entities => {
  const orders = Object.keys(entities).map(id => entities[id as unknown as number]) as Order[];
  return orders.sort((a, b) => (new Date(a.processedAt).getTime() <= new Date(b.processedAt).getTime() ? 1 : -1));
});
export const getOrdersLoading = createSelector(getOrdersState, fromOrders.getOrdersLoading);
export const getOrdersLoaded = createSelector(getOrdersState, fromOrders.getOrdersLoaded);
export const getOrdersErrors = createSelector(getOrdersState, fromOrders.getOrdersErrors);
export const getOrdersPageInfo = createSelector(getOrdersState, fromOrders.getOrdersPageInfo);

export const getSelectedOrder = createSelector(getOrders, fromRoot.getRouterState, (orders, router) => {
  return router.state && orders.find(a => a.orderNumber.toString() === router.state.params['id']);
});
